import { businessCorporateLawModule } from "./BusinessCorporateLaw";
import { criminalLawModule } from "./CriminalLaw";
import { employmentLabourLawModule } from "./EmploymentLabourLaw";
import { debtFinancialLegalModule } from "./DebtFinancialLegal";
import { estatePlanningInheritanceModule } from "./EstatePlanningInheritance";
import { immigrationTravelLawModule } from "./ImmigrationTravelLaw";
import { landPropertyLawLegalModule, landPurchaseVerificationModule } from "./LandPurchaseAndVerification";
import { marriageFamilyLawModule } from "./MarriageFamilyLaw";
import { personalInjuryClaimsModule } from "./PersonalInjuryClaims";
import { bestBettingPlatformsModule } from "./BestBettingPlatforms";
import { sportsBettingTipsModule } from "./SportsBettingTips";
import { mobileBettingAppsModule } from "./MobileBettingApps";
import { esportsBettingModule } from "./EsportsBetting";
import { responsibleGamblingModule } from "./ResponsibleGambling";
import { bonusesPromotionsModule } from "./BonusesPromotions";
import { casinoGamesModule } from "./CasinoGames";
import { oddsComparisonStrategyModule } from "./OddsComparisonStrategy";
import { paymentMethodsModule } from "./PaymentMethods";
import { virtualGamesModule } from "./VirtualGames";

const SUBCATEGORY_MODULES = [
  landPurchaseVerificationModule,
  landPropertyLawLegalModule,
  marriageFamilyLawModule,
  businessCorporateLawModule,
  criminalLawModule,
  employmentLabourLawModule,
  immigrationTravelLawModule,
  estatePlanningInheritanceModule,
  debtFinancialLegalModule,
  personalInjuryClaimsModule,
  bestBettingPlatformsModule,
  sportsBettingTipsModule,
  mobileBettingAppsModule,
  esportsBettingModule,
  responsibleGamblingModule,
  bonusesPromotionsModule,
  casinoGamesModule,
  oddsComparisonStrategyModule,
  paymentMethodsModule,
  virtualGamesModule,
];

export function getSubcategoryRichModule(slug) {
  return SUBCATEGORY_MODULES.find((m) => m.slug === slug) ?? null;
}
